import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ViewSheetHeaderRowProps = ComponentProps<"div">

/**
 * Puts the sheet's info grid and toolbar on ONE row when the sheet is wide
 * enough — the grid's blank right side is exactly where the toolbar fits —
 * and lets the toolbar wrap back under the grid when it isn't. Compose the
 * info grid first, the toolbar second.
 */
function ViewSheetHeaderRow(props: ViewSheetHeaderRowProps) {
  const { className, ...divProps } = props
  return (
    <div className={cn("view-sheet-header-row", className)} {...divProps} />
  )
}

export default ViewSheetHeaderRow
